import { render, staticRenderFns } from "./acceptance.vue?vue&type=template&id=2972b76e&scoped=true"
import script from "./acceptance.vue?vue&type=script&lang=js"
export * from "./acceptance.vue?vue&type=script&lang=js"
import style0 from "./acceptance.vue?vue&type=style&index=0&id=2972b76e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972b76e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2972b76e')) {
      api.createRecord('2972b76e', component.options)
    } else {
      api.reload('2972b76e', component.options)
    }
    module.hot.accept("./acceptance.vue?vue&type=template&id=2972b76e&scoped=true", function () {
      api.rerender('2972b76e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/courseDeclare/acceptance.vue"
export default component.exports